import * as React from "react";
import Typography from "@mui/material/Typography";
import Stack from "@mui/material/Stack";

export default function LearnMore() {
  return (
    <Stack
      sx={{
        padding: 1,
        justifyContent: "center",
        alignItems: "center",
      }}
    >
      <Typography
        gutterBottom
        sx={{ fontWeight: 600, justifyContent: "center", alignItems: "center" }}
      >
        U.S. Government Rights
      </Typography>
      <Typography variant="body2" sx={{ color: "text.secondary" }}>
        This product includes CPT and/or CPT® Changes which are commercial
        technical data, which was developed exclusively at private expense by
        the American Medical Association, 330 North Wabash Avenue, Chicago,
        Illinois 60611. The American Medical Association does not agree to
        license CPT to the Federal Government based on the license in FAR
        52.227-14 (Data Rights - General) and DFARS 252.227-7015 (Technical Data
        - Commercial Items) or any other license provision. The American Medical
        Association reserves all rights to approve any license with any Federal
        agency.
      </Typography>
    </Stack>
  );
}
